function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c32126;}.cls-2{fill:#fff;}.cls-3{fill:#231f20;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "xmas-hat");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42.35,55.66l-3.61-3.21s13.69-16.17,23-17.28c1.08-.13,8.3,1.07,11.7,4.6S90.61,58,93,73.27s5.55,16.59,5.55,16.59l-13,3.54-19.3,1.1L49.16,92.1S51.33,80,52.48,77.71s6.14-22.64,6.14-22.64L53.9,57.68l-6.14.68L43,58.15Z",
  transform: "translate(-30.18 -34.36)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.09,56.88s2.29-5.1,7-4,5.26,6.62,5.26,6.62l-1.51,3.75L38,64.94,33.27,63l-2.58-3.93Z",
  transform: "translate(-30.18 -34.36)"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "30.23 59.41 16.57 57.9 12.09 63.47 13.09 69.55 27.49 72.87 55.16 72.22 72.65 67.65 75.48 63.58 70.86 54.71 58.7 58.1 41.4 60.28 30.23 59.41"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M98.54,88.36c-6.6,1.74-16.2,7.81-44.42,3.9-3.1-.43-7.51-2.47-10.07,1s-4.8,7.83-2,10.76,16.34,5,30.95,4.12,24.45-2.6,30.76-5.87C108.81,99.68,105.14,86.62,98.54,88.36Zm3.61,12.76c-2.19,1.47-15.48,4.4-20.47,4.84s-38.89,1.92-38.27-5.42c0.64-7.5,4.92-7.54,4.92-7.54,2,0,17.09,3.14,31.72,1.77,15.58-1.46,19.52-7.14,22.2-2.75S104.34,99.65,102.15,101.12Z",
  transform: "translate(-30.18 -34.36)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M58,53.51S54.7,59,43.32,56.66L43,58.15c3,0.92,10.26,2.64,14.4-.86,0,0-9.93,28.56-9,35.72L50,92.94S58,57.34,62.29,49C62.29,49,59.15,48.12,58,53.51Z",
  transform: "translate(-30.18 -34.36)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M64.19,34.58C53,32.14,38.28,51,37.48,52.3l2.88,0.34c1.51-3,14.3-18.37,23-16.49,8.18,1.77,23.38,9.59,32.9,53.82l2.3-.1S90.17,40.21,64.19,34.58Z",
  transform: "translate(-30.18 -34.36)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M37.43,51.87c-4.73.49-8.38,3.65-6.92,8.33S42.89,70.56,44,58.28C44,58.28,42.16,51.38,37.43,51.87ZM31.77,59c-0.91-6.89,7.83-5.84,9.8-2.36C46.16,64.76,32.73,66.3,31.77,59Z",
  transform: "translate(-30.18 -34.36)"
});

var SvgChristmas = function SvgChristmas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "christmas",
    "data-name": "christmas",
    viewBox: "0 0 75.95 73.97",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChristmas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/christmas.d9619f48.svg";
export { ForwardRef as ReactComponent };